export var FETCH_FORM_MANAGER = '@redux-core-modules/FETCH_FORM_MANAGER';
export var fetchFormManagerSagaAction = function (payload) { return ({
    type: FETCH_FORM_MANAGER,
    payload: payload,
}); };
